// socketprovider.jsx
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import config from "@/config";

const SocketContext = createContext(null);

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
  const [socketInstance, setSocketInstance] = useState(null);
  const socketRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem(config.LOCAL_KEYS.SIGNUP_TOKEN);
    const socket = io(config.API_URL, {
      transports: ["websocket"],
      query: { token },
    });

    socketRef.current = socket;
    setSocketInstance(socket);

    socket.on("connect", (id) => {
      console.log("✅ Socket connected", socket.id);
      socket.emit("joinRoom", { token });
    });
    socket.on("joined", (response) => {
      console.log("Joined room:", response);
    });
    console.log(socket.id," Socket ID");
    socket.on("newData", (newData) => {
      console.log("New data received from server:", newData);
      // Handle new data as needed
    });
    return () => {
      socket.disconnect();
      socketRef.current = null;
      setSocketInstance(null);
      console.log("❌ Socket disconnected");
    };
  }, []);

  return (
    <SocketContext.Provider value={socketInstance}>
      {children}
    </SocketContext.Provider>
  );
};
